import {useEffect} from 'react';

export function usePosterEditorPrefetchModules(): void {
  useEffect((): void => {
    void prefetchModules();
  }, []);

  const prefetchModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/stock-panel');
    await import(/* webpackPrefetch: true */ '@Panels/user-media-panel');
  };
}
